// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1Jmkw","title":"ClientInsurance_title__2-Xft","itemText":"ClientInsurance_itemText__5CMQx"};